module.exports = __webpack_public_path__ + "static/media/premierOneRightSeat.2dcd0f91.svg";